import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import ReactPlayer from 'react-player/lib/ReactPlayer';
import { PlayerIcon, Direction, Slider } from 'react-player-controls';
import videoIcon from '~/assets/img/video/play.svg';
import Loading from './loading';
import './style.scss';

let videoplayer_instance_id = 0;

const containerStyle = {
  paddingTop: '56.25%',
  position: 'relative',
};

@inject('igStore')
class VideoPlayer extends Component {
  state = {
    height: 159,
    source: '',
    orientation: null,
    fullScreened: false,
    buttonFS: false,
    videoError: false
  };

  retryTimeout;

  videoContainer = React.createRef();
  player = React.createRef();

  setHeight = () => {
    if (this.videoContainer.current) {
      const height = this.videoContainer.current.clientHeight;
      this.setState(prevState => (height !== prevState.height ? { height } : null));
    }
  };

  // handleOrientationChange = () => {
  //
  //   const {playing} = this.props.igStore.video;
  //   if (window.screen && window.screen.orientation) {
  //     if (window.screen.orientation.type.startsWith('landscape')) {
  //       playing &&
  //       !this.state.fullScreened &&
  //       document.getElementById('videoplayer').webkitRequestFullscreen();
  //       this.setState({
  //         orientation: 'landscape',
  //       });
  //     } else {
  //       playing && !this.state.buttonFS && this.state.fullScreened && document.webkitExitFullscreen();
  //       this.setState({
  //         orientation: 'portrait',
  //       });
  //     }
  //   }
  //   this.setHeight();
  // };

  toggleFullScreen = ({ autoFullScreen } = {}) => {

    if (document.fullscreenElement) {
      this.setState({
        buttonFS: false,
      });
      document.webkitExitFullscreen();
    } else {
      this.setState({
        buttonFS: !autoFullScreen,
      });
      document.getElementById('videoplayer').webkitRequestFullscreen();
    }
  };

  // handleFullScreenChange = () => {
  //   debugger;
  //   this.setState({
  //     fullScreened: !this.state.fullScreened
  //   });
  // };

  componentDidMount() {
    videoplayer_instance_id += 1;
    this.videoplayer_instance_id = videoplayer_instance_id;
    // if ((window.screen && window.screen.orientation)) {
    //   window.screen.orientation.onchange = this.handleOrientationChange;
    //   if (window.screen.orientation.type.startsWith('landscape')) {
    //     this.setState({
    //       orientation: 'landscape',
    //     });
    //   } else {
    //     this.setState({
    //       orientation: 'portrait',
    //     });
    //   }
    //   this.setHeight();
    //   document.addEventListener('fullscreenchange', this.handleFullScreenChange, false);
    //   document.addEventListener('mozfullscreenchange', this.handleFullScreenChange, false);
    //   document.addEventListener('MSFullscreenChange', this.handleFullScreenChange, false);
    //   document.addEventListener('webkitfullscreenchange', this.handleFullScreenChange, false);
    //
    // }
  }

  componentDidUpdate() {
    this.setHeight();
  }

  componentWillUnmount() {
    this.props.onChange('started', false);

    if (this.retryTimeout) {
      clearTimeout(this.retryTimeout);
    }
  }

  overlay = React.createRef();

  onReady = playerRef => {
    if (/twitch/.test(this.props.source)) {
      playerRef.getInternalPlayer().showPlayerControls(false);
    } else if (/youtu(\.be|be)/.test(this.props.source)) {
      setTimeout(() => {
        const player = playerRef.getInternalPlayer();
        if (player) {
          player.addEventListener('onError', () => {
            if (this.overlay.current) {
              this.overlay.current.classList.add('hidden');
            }
          });
        }
      }, 0);
    } else if (/vimeo/.test(this.props.source)) {
      // To show custom play icon
      this.props.onChange('started', true);
    } else {
      // To show custom play icon
      this.props.onChange('started', true);
    }

    this.props.onChange('ready', true);
  };

  onStart = () => {
    if (/twitch/.test(this.props.source)) {
      this.props.onChange('started', false);
    } else {
      this.props.onChange('started', true);
    }

    if (this.player.current.player.player.hls && this.props.silent) {
      this.player.current.player.seekTo(this.player.current.player.getSecondsLoaded());
      this.props.onChange('silent', false);
    }
  };

  handleError = err => {
    const { ready, gid } = this.props;
    if (videoplayer_instance_id !== this.videoplayer_instance_id) return;
    this.setState({videoError: true})
    console.log('An error occurred while attempting to play video', err);
    if (!ready && gid) {
      if (this.retryTimeout) {
        clearTimeout(this.retryTimeout);
      }
      this.retryTimeout = setTimeout(() => {
        console.log('A new request to obtain video is sent', gid);
        this.props.igStore.getVideo({ gid, silent: true, retry: true });
      }, 1000);
    }
  };

  render() {
    const {
      playing,
      volume,
      title,
      detached,
      handleDetach,
      toggleList,
      started,
      ready,
      isLoading,
      source,
    } = this.props;
    const { height, videoError } = this.state;

    if (this.state.fullScreened && this.state.orientation === 'landscape') {
      const { innerHeight, innerWidth } = window;
      containerStyle.paddingTop = `${(innerHeight > innerWidth
        ? innerWidth / innerHeight
        : innerHeight / innerWidth) * 100}%`;
    }
    if (this.state.fullScreened && this.state.orientation === 'portrait') {
      containerStyle.top = '50%';
      containerStyle.transform = 'translateY(-50%)';
    }
    
    const CONFIG = {
      youtube: {
        playerVars: {
          showinfo: 0,
          autoplay: 1,
        },
      },
      vimeo: {
        playerOptions: {
          controls: 0,
          showinfo: 0,
          autoplay: 1,
        },
      },
      twitch: {
        options: {
          autoplay: 1,
          showinfo: 0,
        },
      },
    };
    
    return (
      <div className="videoplayer" ref={this.videoContainer} id="videoplayer">
        <div className="relative">
          {!ready && (
            <div className="absolute videoplayer-hider" style={{ height }}>
              <Loading videoError={videoError} />
            </div>
          )}
        </div>

        <div style={containerStyle}>
          <div className="videoplayer__container" style={{ zIndex: 0 }}>
            {!isLoading && (
              <ReactPlayer
                url={source}
                onReady={this.onReady}
                onPlay={() => {
                  this.props.onChange('playing', true);
                  // if (this.state.orientation === 'landscape' && !this.state.fullScreened) {
                  //   this.toggleFullScreen({autoFullScreen: true});
                  // }
                }}
                onPause={() => this.props.onChange('playing', false)}
                onStart={this.onStart}
                ref={this.player}
                onError={this.handleError}
                playing={playing}
                volume={volume}
                controls={false}
                width="100%"
                height="100%"
                config={CONFIG}
                style={{ position: 'absolute', top: 0, left: 0 }}
                playsinline
                pip={detached}
              />)}

            {ready && (
              <div className="videoplayer__overlay" style={{ zIndex: 2 }} ref={this.overlay}>

                <div className="videoplayer__title" onClick={toggleList}>
                  <i className="videoplayer__title__icon" />
                  <div className="videoplayer__title__desc">{title}</div>
                </div>

                <div
                  className='videoplayer__toggle-play'
                  onClick={() => this.props.onChange('playing', !playing)}
                >
                  {started && !playing && <img src={videoIcon} alt="" />}
                </div>
                <Controls
                  volume={volume}
                  playing={playing}
                  setPlaying={value => this.props.onChange('playing', value)}
                  setVolume={value => this.props.onChange('volume', value)}
                  handleFullScreen={this.toggleFullScreen}
                  handleDetach={handleDetach}
                  detached={detached}
                  // supportPip={ window.document.pictureInPictureEnabled && this.player.current && this.player.current.player.player.hls }
                  fullScreened={this.state.fullScreened}
                />
              </div>)}

          </div>
        </div>
      </div>
    );
  }
}

const Controls = ({
  volume,
  playing,
  detached,
  fullScreened,
  setPlaying,
  setVolume,
  handleDetach,
  handleFullScreen,
  supportPip
}) => {
  const iconStyle = { width: 15, fill: '#fff' };
  return (
    <div
      className={classNames('videoplayer__controls', {
        videoplayer__controls__mobile: false,
        videoplayer__controls__mobile__fullscreen: fullScreened,
      })}
    >
      {playing ? (
        <PlayerIcon.Pause style={iconStyle} onClick={() => setPlaying(false)} />
      ) : (
        <PlayerIcon.Play style={iconStyle} onClick={() => setPlaying(true)} />
      )}
      {volume ? <PlayerIcon.SoundOn style={iconStyle} onClick={() => setVolume(0)} /> : null}
      {!volume ? <PlayerIcon.SoundOff style={iconStyle} onClick={() => setVolume(0.5)} /> : null}
      <Slider
        style={{
          width: 50,
          height: 4,
          borderRadius: 2,
          background: 'rgba(255,255,255,0.5)',
          transition: 'width 0.1s',
          cursor: 'pointer',
          opacity: 1.0,
        }}
        direction={Direction.HORIZONTAL}
        isEnabled
        onChange={val => setVolume(val)}
        onChangeStart={val => setVolume(val)}
        onChangeEnd={val => val !== null && setVolume(val)}
      >
        <SliderBar value={volume} />
        <SliderHandle value={volume} />
      </Slider>
      {/*{ getClientV() === 'mobile' ? (*/}
      {/*  <FullScreenIcon*/}
      {/*    style={ {...iconStyle, marginLeft: 'auto'} }*/}
      {/*    onClick={ handleFullScreen }*/}
      {/*    fullScreened={ fullScreened }*/}
      {/*  />*/}
      {/*) : (*/}
      {supportPip ? <DetachIcon
        style={{ ...iconStyle, marginLeft: 'auto' }}
        onClick={handleDetach}
        detached={detached}
      /> : null}
      {/*) }*/}
    </div>
  );
};

const SliderBar = ({ value }) => (
  <div
    style={{
      position: 'absolute',
      borderRadius: 2,
      top: 0,
      bottom: 0,
      left: 0,
      width: `${value * 100}%`,
      background: '#fff',
    }}
  />
);

const SliderHandle = ({ value }) => (
  <div
    style={{
      position: 'absolute',
      width: 8,
      height: 8,
      background: '#fff',
      borderRadius: '100%',
      transform: 'scale(1)',
      transition: 'transform 0.2s',
      '&:hover': {
        transform: 'scale(1.3)',
      },
      top: 0,
      left: `${value * 100}%`,
      marginTop: -2,
      marginLeft: -4,
    }}
  />
);

const DetachIcon = ({ detached, ...rest }) => (
  <svg {...rest} viewBox="0 0 21 17">
    {detached ? (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.52686 2.0105H17.406C17.9583 2.0105 18.406 2.45822 18.406 3.0105V13.8852C18.406 14.4375 17.9583 14.8852 17.406 14.8852H3.52686C2.97461 14.8852 2.52686 14.4375 2.52686 13.8852V3.0105C2.52686 2.45822 2.97461 2.0105 3.52686 2.0105ZM0.526855 3.0105C0.526855 1.35364 1.87 0.010498 3.52686 0.010498H17.406C19.0629 0.010498 20.406 1.35364 20.406 3.0105V13.8852C20.406 15.5421 19.0629 16.8852 17.406 16.8852H3.52686C1.87 16.8852 0.526855 15.5421 0.526855 13.8852V3.0105ZM13.0435 4.01843C12.4912 4.01843 12.0435 4.46616 12.0435 5.01843V11.9484C12.0435 12.5007 12.4912 12.9484 13.0435 12.9484H15.4131C15.9655 12.9484 16.4131 12.5007 16.4131 11.9484V5.01843C16.4131 4.46616 15.9655 4.01843 15.4131 4.01843H13.0435Z"
      />
    ) : (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.29395 2.09668H17.1731C17.7253 2.09668 18.1731 2.5444 18.1731 3.09668V13.9714C18.1731 14.5237 17.7253 14.9714 17.1731 14.9714H3.29395C2.7417 14.9714 2.29395 14.5237 2.29395 13.9714V3.09668C2.29395 2.5444 2.7417 2.09668 3.29395 2.09668ZM0.293945 3.09668C0.293945 1.43982 1.63708 0.0966797 3.29395 0.0966797H17.1731C18.83 0.0966797 20.1731 1.43982 20.1731 3.09668V13.9714C20.1731 15.6282 18.83 16.9714 17.1731 16.9714H3.29395C1.63708 16.9714 0.293945 15.6282 0.293945 13.9714V3.09668ZM9.37109 7.53638C8.81885 7.53638 8.37109 7.9841 8.37109 8.53638V12.0347C8.37109 12.5869 8.81885 13.0347 9.37109 13.0347H15.1803C15.7325 13.0347 16.1803 12.5869 16.1803 12.0347V8.53638C16.1803 7.9841 15.7325 7.53638 15.1803 7.53638H9.37109Z"
      />
    )}
  </svg>
);
//
// const FullScreenIcon = ({fullScreened, ...rest}) => {
//   return fullScreened ? (
//     <svg
//       { ...rest }
//       width="14"
//       height="14"
//       viewBox="0 0 14 14"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <line
//         x1="1"
//         y1="5"
//         x2="5"
//         y2="5"
//         stroke="white"
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <line
//         x1="5"
//         y1="1"
//         x2="5"
//         y2="5"
//         stroke="white"
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <line
//         x1="9"
//         y1="1"
//         x2="9"
//         y2="5"
//         stroke="white"
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <line
//         x1="13"
//         y1="5"
//         x2="9"
//         y2="5"
//         stroke="white"
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <line
//         x1="13"
//         y1="9"
//         x2="9"
//         y2="9"
//         stroke="white"
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <line
//         x1="9"
//         y1="13"
//         x2="9"
//         y2="9"
//         stroke="white"
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <line
//         x1="5"
//         y1="13"
//         x2="5"
//         y2="9"
//         stroke="white"
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <line
//         x1="1"
//         y1="9"
//         x2="5"
//         y2="9"
//         stroke="white"
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   ) : (
//     <svg
//       { ...rest }
//       width="19"
//       height="14"
//       viewBox="0 0 19 14"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M17.593 13.198H1.63296C1.20736 13.198 0.834961 12.8256 0.834961 12.4V0.90884C0.834961 0.48324 1.20736 0.11084 1.63296 0.11084H17.593C18.0186 0.11084 18.391 0.48324 18.391 0.90884V12.4C18.391 12.8256 18.0186 13.198 17.593 13.198ZM2.37776 11.602H16.7418V1.70684H2.37776V11.602Z"
//         fill="white"
//       />
//     </svg>
//   );
// };

const NewWindowIcon = (props) => <svg viewBox="0 0 13 10" fill="#687a94" style={{ width: 50, cursor: 'pointer' }} {...props}>
  <rect x="2.5" y="0.5" width="10" height="7" stroke="#687a94" fill="none" />
  <rect y="2" width="1" height="8" />
  <rect y="9" width="11" height="1" />
  <rect x="1" y="2" width="1" height="1" />
  <rect x="10" y="8" width="1" height="1" />
</svg>;

export const canPlay = src => ReactPlayer.canPlay(src);

export const openWindow = src => {
  const windowWidth = 660;
  const windowHeight = 460;
  window.open(
    src,
    `video ${src}`,
    `toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=no,width=${windowWidth},height=${windowHeight},left=-${window
      .screen.width -
    windowWidth -
    100},top=10,resizable=no`,
  );
};

@inject('igStore', 'accountStore')
@observer
export default class VideoPlayerWrapper extends Component {
  state = {
    initialX: 0,
    initialY: 0,
  };

  el = React.createRef();

  render() {
    let content = null;
    let error;
    const { igStore, games, force, accountStore } = this.props;

    const { video } = igStore;

    if (!force) {
      if (video.error) {
        if (video.error === 3) {
          content = (
            <div className="videoplayer-error">
              <div className="videoplayer-error__text">
                {window.getLang('TOP_UP_BALANCE_TO_VIEW')}
              </div>
              <Link className="flat_button" to="/finance/deposit">
                {window.getLang('TO_DEPOSIT')}
              </Link>
            </div>
          );
        } else if (video.error === 2) {
          content = (
            <div className="videoplayer-error">
              <div className="videoplayer-error__text">
                {window.getLang('PLEASE_AUTH_TO_VIEW_THE_BROADCAST')}
              </div>
              <button className="flat_button" onClick={() => accountStore.toggleLoginForm()}>
                {window.getLang('SIGN_IN')}
              </button>
            </div>
          );
        } else {
          content = (
            <div className="videoplayer-error">
              <div className="videoplayer-error__text">{window.getLang(video.error)}</div>
            </div>
          );
        }
        error = true;
      } else if (!video.src) {
        return false;
      } else if (video.type === 4) { // FIXME продумать более универсальное решение
        error = true;
        content = this.createFrame(video.src);
      } else if (!canPlay(video.src) && video.type !== 4) {
        error = true;
        content = <div className="videoplayer-error">
          <NewWindowIcon onClick={() => openWindow(video.src)} />
        </div>;
      }
    }

    if (!error) {
      content = (
        <VideoPlayer
          games={games}
          playing={video.playing}
          volume={video.volume}
          source={video.src}
          title={video.title}
          started={video.started}
          ready={video.ready}
          gid={video.gid}
          onChange={igStore.setVideoParam}
          handleDetach={igStore.toggleDetachVideo}
          toggleList={igStore.toggleVideoList}
          detached={video.detached}
          handleFullScreen={igStore.toggleFullScreenVideo}
          fullScreened={video.fullScreened}
        />
      );
    }

    console.log(content);
    const wrapper = (
      <Fragment>
        <div
          className={classNames('videoplayer-wrapper', { 'videoplayer-wrapper-hidden': false })}
          ref={this.el}
        >
          {content}
        </div>
      </Fragment>
    );
    if (video.detached) {
      return (
        <DetachedPortal>
          <div
            style={{ transform: `translate(${video.left}px, ${video.top}px)` }}
            className="video-container"
          >
            {wrapper}
          </div>
        </DetachedPortal>
      );
    }
    return wrapper;
  }

  createFrame = url => {
    const frame = `<iframe src='//uma.media/play/embed/${url}\' frameborder='0' class="video-frame-i"></iframe>`;
    return <div style={containerStyle} dangerouslySetInnerHTML={{ __html: frame }} />
  };

  onDrag = e => {
    const { pageX, pageY } = e.type === 'touchmove' ? e.touches[0] : e;

    if (!pageY || !pageY) return;

    const rect = this.el.current.getBoundingClientRect();

    const deltaX = pageX - window.innerWidth + rect.width - this.state.initialX;
    const deltaY = pageY - window.innerHeight + rect.height - this.state.initialY;

    if (deltaX > 0 || deltaX - rect.width < -window.innerWidth) return;
    if (deltaY > 0 || deltaY - rect.height < -window.innerHeight) return;

    this.props.igStore.setVideoPosition(deltaX, deltaY);
  };

  onDragEnd = () => {
    this.el.current.classList.remove('dragging');
  };

  onDragStart = e => {
    this.el.current.classList.add('dragging');
    const rect = this.el.current.getBoundingClientRect();
    const { pageX, pageY } = e.type === 'touchmove' ? e.touches[0] : e;

    if (e.type === 'drag') {
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setDragImage(new Image(), 0, 0);
    }
    this.setState({ initialX: pageX - rect.left, initialY: pageY - rect.top });
  };
}

const DetachedPortal = ({ children }) =>
  ReactDOM.createPortal(children, document.getElementById('video-container'));


// WEBPACK FOOTER //
// ./src/components/videoplayer/index.js